<template>
  <span
    class="block text-center text-base font-normal leading-normal"
    :class="[
      {'font-bold': bold},
      {[`${colorValriants[color]}`]: color},
      {[`leading-${leading}`]: leading},
      {[`${size}`]: size}
    ]"
  >
    <slot />
  </span>
</template>

<script setup>
defineProps({
  bold: {
    type: Boolean,
    default: false
  },
  color: {
    type: [String, Boolean], // blue, gray
    default: false
  },
  size: {
    type: String,
    required: true //sm, md, lg, xl, 2xl, 4xl
  },
  leading: {
    type: String,
    required: true
  }
})

const colorValriants = {
  blue: 'text-blue-600',
  gray: 'text-slate-500',
  white: 'text-white'
}
</script>

<style lang="scss" scoped></style>
